<template>
    <div>
        <main id="top">
            <section id="hero">
                <div class="container">
                    <div class="flex-wrapper">
                        <div class="hero-text">

                            <h1 class="hero-title">
                                A estratégia que faltava para você <span>lucrar</span> como os melhores do Brasil
                            </h1>

                            <a href="#/pagamento_plano_startplus" class="btn-theme" style="font-size: 1.3rem">
                                INICIE AGORA
                            </a>
                        </div>
                        <div class="video">
                            <div class="video-element">
                                <div class="bg" style="background: url(./static/img/elements/vd1.jpg) no-repeat 50%/cover;">
                                    <a href="#" data-toggle="modal" data-target="#videoModal">
                                        <img src="static/img/icons/play.svg" alt="play button">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="media">
                <div class="container">

                    <h2 class="section-title">
                        Você terá acesso
                    </h2>

                    <br><br>

                    <div class="row">
                        <div class="col-12 col-md-4 col-xl-4">
                          <div class="benefit-item ">
                            <img src="static/img/elements/ppl1.jpg" alt="benefit image" class="w-100">
                            <hr>
                              <h4 class="title text-center">
                                  Videoaulas Exclusivas
                              </h4>
                              <hr>

                              <p class="short-description text-justify">
                                  Você terá acesso a área do aluno com vídeo
                                  aulas em que serão abordados conteúdos
                                  completos sobre <strong>Análise Probalilística</strong>,
                                  Gráfica, Técnica e Fundamentalista, além de um material
                                  sobre Gerenciamento de Risco e Psicologia
                                  do Trader desenvolvido pelos melhores traders do Brasil.
                              </p>
                          </div>
                          <br>
                        </div>
                        

                        <div class="col-12 col-md-4 col-xl-4">
                          <div class="benefit-item">
                            <img src="static/img/elements/ppl3.jpg" alt="benefit image" class="w-100">
                            <hr>
                            <h4 class="title text-center">
                                Salas de Operação ao Vivo
                            </h4>
                            <hr>
                            <p class="short-description text-justify">
                                Todas as terças e quinta-feiras, você participará das
                                nossas salas de aula prática em tempo real junto
                                com nosso time de instrutores que irão lhe auxiliar
                                ao vivo em suas operações, esclarecendo suas
                                dúvidas, com objeivo de você se tornar profissonal e
                                independente.
                            </p>
                          </div>
                        </div>
                        <br>

                        <div class="col-12 col-md-4 col-xl-4">
                            <div class="benefit-item">
                              <img src="static/img/elements/ppl2.jpg" alt="benefit image" class="w-100">
                              <hr>
                              <h4 class="title text-center">
                                  Ferramentas de Apoio
                              </h4>
                              <hr>
                              <p class="short-description text-justify">
                                  Criamos a primeira ferramenta de <strong>catalogação
                                   gráfico-probabilistico</strong> exclusiva para você ter mais
                                  agilidade e consistência na hora da tomada de
                                  decisão das suas operações, e um <strong>gerenciador
                                  matemático</strong> que calcula o retorno de suas negociações
                                  com o lucro esperado.
                              </p>
                            </div>
                        </div>
                        <br>
                    </div>
                </div>
            </section>

            <section id="testimonials" style="background: url(./static/img/bg/bg.svg) no-repeat 50%/cover;" >
                <div class="container">

                    <h2 class="section-title text-center">
                        Casos de sucesso
                    </h2>

                    <h5 class="short-description text-center" >
                        Alguns traders formados por nós
                    </h5>

                    <br>

                    <div class="floating-elements">
                        <img src="static/img/elements/ppl1.png" alt="el1" class="avatar --mv1">
                        <img src="static/img/elements/ppl2.png" alt="el2" class="avatar --mv2">
                        <img src="static/img/elements/ppl3.png" alt="el3" class="avatar --mv3">
                        <img src="static/img/elements/ppl4.png" alt="el4" class="avatar --mv4">
                        <img src="static/img/elements/ppl5.png" alt="el5" class="avatar --mv5">
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4">
                            <div class="swiper-container swiper">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <div class="card-testimonal mx-auto">
                                            <div class="responsive-embed">
                                                <iframe class="embed-responsive-item" width="100%" height="315"
                                                        src="https://player.vimeo.com/video/281484578" frameborder="0"
                                                        allow="autoplay; encrypted-media"
                                                        allowfullscreen="allowfullscreen"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="card-testimonal mx-auto">
                                            <div class="responsive-embed">
                                                <iframe class="embed-responsive-item" width="100%" height="315"
                                                        src="https://player.vimeo.com/video/281484511" frameborder="0"
                                                        allow="autoplay; encrypted-media"
                                                        allowfullscreen="allowfullscreen"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="card-testimonal mx-auto">
                                            <div class="responsive-embed">
                                                <iframe class="embed-responsive-item" width="100%" height="315"
                                                        src="https://player.vimeo.com/video/281484608" frameborder="0"
                                                        allow="autoplay; encrypted-media"
                                                        allowfullscreen="allowfullscreen"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="card-testimonal mx-auto">
                                            <div class="responsive-embed">
                                                <iframe class="embed-responsive-item" width="100%" height="315"
                                                        src="https://player.vimeo.com/video/281484536" frameborder="0"
                                                        allow="autoplay; encrypted-media"
                                                        allowfullscreen="allowfullscreen"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="card-testimonal mx-auto">
                                            <div class="responsive-embed">
                                                <iframe class="embed-responsive-item" width="100%" height="315"
                                                        src="https://player.vimeo.com/video/281484649" frameborder="0"
                                                        allow="autoplay; encrypted-media"
                                                        allowfullscreen="allowfullscreen"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="card-testimonal mx-auto">
                                            <div class="responsive-embed">
                                                <iframe class="embed-responsive-item" width="100%" height="315"
                                                        src="https://player.vimeo.com/video/281484444" frameborder="0"
                                                        allow="autoplay; encrypted-media"
                                                        allowfullscreen="allowfullscreen"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="card-testimonal mx-auto">
                                            <div class="responsive-embed">
                                                <iframe class="embed-responsive-item" width="100%" height="315"
                                                        src="https://player.vimeo.com/video/281484649" frameborder="0"
                                                        allow="autoplay; encrypted-media"
                                                        allowfullscreen="allowfullscreen"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="card-testimonal mx-auto">
                                            <div class="responsive-embed">
                                                <iframe class="embed-responsive-item" width="100%" height="315"
                                                        src="https://player.vimeo.com/video/281484552" frameborder="0"
                                                        allow="autoplay; encrypted-media"
                                                        allowfullscreen="allowfullscreen"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-slide">
                                        <div class="card-testimonal mx-auto">
                                            <div class="responsive-embed">
                                                <iframe class="embed-responsive-item" width="100%" height="315"
                                                        src="https://player.vimeo.com/video/281484488" frameborder="0"
                                                        allow="autoplay; encrypted-media"
                                                        allowfullscreen="allowfullscreen"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                      <!-- <h4 class="name text-center">
                                          Nome
                                      </h4>

                                      <p class="prof text-center">
                                          Profissāo / Empresa
                                      </p> -->
                                </div>
                            </div>
                            <div class="swiper-button-prev"></div>
                            <div class="swiper-button-next"></div>
                            <div class="swiper-pagination"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="benefits">
                <div class="container">

                    <h2 class="section-title text-center">
                        Sala de Imprensa
                    </h2>
                    <h5 class="short-description text-center">
                      A Top Trader já foi destaque em
                    </h5>

                    <div class="swiper-container swiper-benefit">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                              <div class="benefit-item">
                                  <a href="https://blog.top-trader.org/top-trader-na-midia-jovem-pan/" height="400px" width="400px" target="_blank" rel="noopener">
                                      <img src="static/img/brands/logo-jovem-pam.png" alt="Jovem pam">
                                  </a>
                              </div>
                            </div>

                            <div class="swiper-slide">
                              <div class="benefit-item">
                              <a href="https://blog.top-trader.org/top-na-midia-isto-e/" height="400px" width="400px" target="_blank" rel="noopener">
                                  <img src="static/img/brands/logo-istoe.png" alt="istoé">
                              </a>
                              </div>
                            </div>

                            <div class="swiper-slide">
                              <div class="benefit-item">
                              <a href="https://blog.top-trader.org/toptrader-na-midia-record/" target="_blank" rel="noopener">
                                  <img src="static/img/brands/logo-record.png" alt="record">
                              </a>
                              </div>
                            </div>

                            <div class="swiper-slide">
                              <div class="benefit-item">
                              <a href="https://blog.top-trader.org/toptrader-na-midia-empreendedores-de-sucesso/" target="_blank" rel="noopener">
                                    <img src="static/img/brands/logo-sebrae.png" alt="sebrae">
                                </a>
                              </div>
                            </div>
                        </div>
                      <div class="swiper-pagination"></div>

                    </div>
                </div>

            </section>

            <section style="background-color: #212529">
                  <br><br>
              <div class="col-12" >
                <div class="form-group d-flex justify-content-center centered">
                    <!-- <button type="submit" class="btn btn-round btn-outline btn-primary btn-icon btn-wd"
                     @click.prevent="payment()"
                    >
                      <h2>
                        GARANTA SUA VAGA AGORA
                      </h2>
                    </button> -->
                      <router-link
                      class="btn btn-round  btn-icon btn-wd"
                      to="/pagamento_plano_startplus"
                      href="/promocional"
                      @click.native="$scrollToTop"
                      >
                      <h2>
                        GARANTA SUA VAGA AGORA
                      </h2>
                    </router-link>

                </div>
              </div>
                    <br> <br>
            </section>
        </main>
        <div class="cta-bar">
            <p class="cta-text">
                <span class="desktop">
                    Faça sua matricula agora no plano de
                </span>

                <span class="mobile">
                    R$ 49,90 /mês
                </span>

                <span class="desktop">
                    antes de
                </span>
            </p>

            <div class="cta-counter" style="padding-right: 7px; padding-left: 7px;">
                <span class="time">
                    {{timeFromFinished === -1 ? '0:0:0' : (timeFromFinished[0]+':'+timeFromFinished[1]+':'+timeFromFinished[2]) }}
                </span>
            </div>

            <!-- <router-link
              class="btn btn-round btn-outline btn-primary btn-icon btn-wd"
              to="/pagamento_plano_startplus"
              href="/promocional"
              >
              <h2>
                GARANTA SUA VAGA AGORA
              </h2>
            </router-link> -->

            <a href="#/pagamento_plano_startplus" class="btn-theme">
                <span class="desktop" style="font-size: 1rem">
                    GARANTIR MINHA VAGA
                </span>

                <span class="mobile">
                    GARANTIR MINHA VAGA
                </span>
            </a>
        </div>
        <footer>
            <div class="layer-1">
                <div class="container">
                    <div class="wrapper">
                        <small>
                            &copy; 2019. TOP TRADER - Todos os direitos reservados
                        </small>
                          <a
                            href="http://res.cloudinary.com/toptrader/raw/upload/v1521742899/TERMOS_E_CONDI%C3%87%C3%95ES_DE_USO_TOP_TRADER_j97vhz.pdf"
                            target="_blank"
                            rel="noopener"
                          >Termos de Serviço</a>

                        <div class="social">
                            <a href="https://www.facebook.com/TopTraderOrg" target="_blank" rel="noopener">
                                <img src="static/img/icons/facebook.svg" target="_blank" alt="https://www.facebook.com/TopTraderOrg">
                            </a>

                            <a href="https://www.instagram.com/toptraderorg/" target="_blank" rel="noopener">
                                <img src="static/img/icons/instagram.svg" target="_blank" alt="https://www.instagram.com/toptraderorg/">
                            </a>

                            <a href="https://www.youtube.com/user/TopTraderCanal" target="_blank" rel="noopener">
                                <img src="static/img/icons/youtube.svg" target="_blank" alt="https://www.youtube.com/user/TopTraderCanal">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <div class="modal fade" id="videoModal" tabindex="-1" role="dialog" aria-labelledby="videoModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>

                        <div class="container">
                            <div class="embed-responsive embed-responsive-4by3">
                                <iframe width="400px" height="100%" class="embed-responsive-item" src="https://player.vimeo.com/video/337325253" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen="allowfullscreen"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { Loading, Select, Option, Dialog, Table, TableColumn, MessageBox } from 'element-ui'
import { mask } from 'vue-the-mask'
import { Checkbox, FadeRenderTransition } from 'src/components/index'
import AuthLayout from './AuthLayout.vue'
import Swiper from 'swiper'
import swal from "sweetalert2";
import moment from "moment";

Vue.prototype.$scrollToTop = () => window.scrollTo(0,0);
Vue.use(Loading.directive);

export default {
  components: {
    Checkbox,
    FadeRenderTransition,
    AuthLayout,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  directives: { mask },
  data() {
    return {
      modals: {
        centered: false
      },
      timeNow: moment(),
      mainSwiper: null,
      benefitsSwiper: null,
    }
  },
  mounted () {
    let vm = this;
    setInterval(function(){
      vm.timeNow = moment();
    }, 1000);
    
    if (this.timeFromFinished === -1 ) {
      this.timeOver();
    }
    this.mainSwiper = new Swiper ('.swiper', {
      direction: 'horizontal',
      slidesPerView: 1,
      effect: 'fade',
      speed: 600,
      loop: true,
      preloadImages: true,
      lazy: true,
      autoplay: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    })
    this.benefitsSwiper = new Swiper ('.swiper-benefit', {
      slidesPerView: 4,
      spaceBetween: 50,
      preloadImages: true,
      autoplay: true,
      allowTouchMove:true,
      mousewheel: {
        sensitivity: 2,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        568: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 0
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

    })
  },
  computed: {
    timeFromFinished() {
      const initDate = moment('2019-06-19');
      const finalDate = moment('2019-06-20');
      const miliseconds = finalDate.diff(this.timeNow);
      if (this.timeNow.isBefore(initDate) || this.timeNow.isSameOrAfter(finalDate)) {
        return -1;
      }
      return [moment.duration(miliseconds).hours()+moment.duration(miliseconds).days()*24, moment.duration(miliseconds).minutes(), moment.duration(miliseconds).seconds()];
    }
  },
  methods: {
    timeOver() {
      console.log("entrou");
      swal({
        title: "Que pena, o tempo desde plano acabou =(",
        text:
          "Mas fique atento as nossas redes sociais para não perder a próxima oportunidade!",
        type: "error",
        confirmButtonText: "Ok! Ir para página principal",
        confirmButtonColor: "#002c44"
      }).then(result => {
        setTimeout(function() {
          window.location.href = "https://top-trader.org/";
        }, 100);
      });
    },
    scrollToTop() {
        window.scrollTo(0,0);
    },
    openModal(centered) {
      this.modals[centered] = true;
    },
    closeModal(centered) {
      this.modals[centered] = false;
    },
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    handleAfterChange(event, slick, currentSlide) {
      console.log("handleAfterChange", event, slick, currentSlide);
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      console.log("handleBeforeChange", event, slick, currentSlide, nextSlide);
    },
    handleBreakpoint(event, slick, breakpoint) {
      console.log("handleBreakpoint", event, slick, breakpoint);
    },
    handleDestroy(event, slick) {
      console.log("handleDestroy", event, slick);
    },
    handleEdge(event, slick, direction) {
      console.log("handleEdge", event, slick, direction);
    },
    handleInit(event, slick) {
      console.log("handleInit", event, slick);
    },
    handleReInit(event, slick) {
      console.log("handleReInit", event, slick);
    },
    handleSetPosition(event, slick) {
      console.log("handleSetPosition", event, slick);
    },
    handleSwipe(event, slick, direction) {
      console.log("handleSwipe", event, slick, direction);
    },
    handleLazyLoaded(event, slick, image, imageSource) {
      console.log("handleLazyLoaded", event, slick, image, imageSource);
    },
    handleLazeLoadError(event, slick, image, imageSource) {
      console.log("handleLazeLoadError", event, slick, image, imageSource);
    },
  },
  watch: {
    timeFromFinished(newValue) {
      if (newValue === -1) {
        this.timeOver();
      }
    }
  }
};
</script>
<style scoped src="@/assets/css/custom.css">
</style>
<style scoped >
.btn {
  padding: 2rem 5rem !important;
  border: 1px solid #007bff !important;
  background-color: #007bff !important;

}
.btn h2 {
  font-weight: 900 !important;
  line-height: 1.5 !important;
  color: #fff;
}
.benefit-item {
box-shadow: 0 4rem 3rem rgba(0, 0, 0, 0.07)
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: transparent;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
  /* .benefit-item img {
    display:block;
    border-radius:.6rem;
    height:194px;
    -o-object-fit:cover;
    object-fit:cover;
    -o-object-position:center;
    object-position:center;
    margin:0 0 2rem
    } */
  .benefit-item .title {
      color:#0e1417;
      font-size:1.6rem;
      margin:0 0 1.5rem;
      }
  .benefit-item .short-description {
    color:#6e6e6e;
    font-size:1.1rem;
    margin:0;
    }
  .el-select .el-input__inner {
    border-radius: 30px;
    margin-top: .15rem;
    padding: 0px 30px 0px 15px;
  }
  .col-12 label {
    color:#707070;
    font-weight:400;
    font-size:1rem;
    letter-spacing:.03rem;
    margin-left:1.2rem;

  }
  .col-4 .benefit-item{
    padding-right: 20px;
    padding-left: 15px;
  }
  /* .col-12 {
    margin: 0px 0px 2.2px;
  } */
    footer .layer-1 .container .wrapper {
         height: 10px;
         min-height: 10px;
    }
    @media (max-width: 767px) {

        footer .layer-1 .container .wrapper {
            height: 0;
            min-height: 0;
            margin: 0 0 45px;
        }

    }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/SaleStartedPlan.vue